<template>
  <div>
    <Headline
      :title="title"
      subtitle="Proceso de viajes simplificado"
      third-text="La habilidad de adaptarnos al cambio es lo que nos diferencia."
      image="integrations"
      variant="dark"
    ></Headline>
    <Section image="integrations-1">
      <Card
        title="Una gestión integral"
        size="lg"
      >En GeoStar dimos un paso mas para garantizar que todo su proceso de compra de viajes esta gestionado integralmente en su sistema ERP o Intranet</Card>
      <Card
        title="Ganancias de capital"
        size="lg"
        variant="list"
      >
        <ul>
          <li>Acceso a nuestro motor de reservas integrado en su ERP/Intranet/Sharepoint</li>
          <li>Reserva en 2 minutos con creación inmediata de su Orden de Compra</li>
          <li>Autorización del viaje en el workflow interno de su empresa</li>
          <li>Integración de la Factura Electrónica con todos los datos contables para que la aprobación sea un mero trámite</li>
        </ul>
      </Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Integración de sistemas',
  path: '/productos/integracion-de-sistemas',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>